import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { EquipmentService } from '../../../service/equipment.service';
import { AuthenticationService } from '../../../service/system/authentication.service';

@Component({
  selector: 'app-facility-detail',
  templateUrl: './facility-detail.component.html',
  styleUrls: ['./facility-detail.component.less']
})
export class FacilityDetailComponent implements OnInit {

  @Input() currentFacility: any;
  @Input() code: any;
  validateForm: FormGroup;
  userInfo: any;
  facilityTypes = [];
  facilitySubtypes = [];
  facilitySubtypesBak = [];
  facilityLevels = [];
  facilityLifeCycles = [];
  facilityDepartments = [];
  facilityCompanies = [];
  facilityRunningStatuses = [];
  facilityLocation = [];
  facilityCurrentStatues = [];
  alarmShow = [{ value: 1, label: '是' }, { value: 0, label: '否' }];
  stateShow = [{ value: 1, label: '是' }, { value: 0, label: '否' }];
  constructor(
    private fb: FormBuilder,
    public message: NzMessageService,
    private authService: AuthenticationService,
    private modal: NzModalRef,
    private equipmentService: EquipmentService
  ) { }

  ngOnInit(): void {
    this.userInfo = this.authService.getCurrentUserInfo();
    this.getEquipmentMaintainData();
    this.validateForm = this.fb.group({
      facilityId: new FormControl({ value: '', disabled: false }, Validators.required),
      facilityName: new FormControl({ value: '', disabled: false }),
      facilityType: new FormControl({ value: '', disabled: false }),
      facilityModel: new FormControl({ value: '', disabled: false }),
      facilityStatus: new FormControl({ value: '', disabled: false }),
      facilityUser: new FormControl({ value: '', disabled: false }),
      userDepartment: new FormControl({ value: '', disabled: false }),
      boughtTime: new FormControl({ value: '', disabled: false }),
      facilityCompany: new FormControl({ value: '', disabled: false }),
      lifeCycle: new FormControl({ value: '', disabled: false }),
      barCode: new FormControl({ value: '', disabled: false }),
      facilityMade: new FormControl({ value: '', disabled: false }),
      facilitySpecs: new FormControl({ value: '', disabled: false }),
      facilityIntact: new FormControl({ value: '', disabled: false }),
      power: new FormControl({ value: 0, disabled: false }),
      facilitySubtype: new FormControl({ value: '', disabled: false }),
      assetLevel: new FormControl({ value: '', disabled: false }),
      voltageType: new FormControl({ value: '', disabled: false }),
      facilitySN: new FormControl({ value: '', disabled: false }),
      storeLocation: new FormControl({ value: '', disabled: false }),
      userLocation: new FormControl({ value: '', disabled: false }),
      changeState: new FormControl({ value: '', disabled: false }),
      repairPeriod: new FormControl({ value: 12, disabled: false }),
      repairLimited: new FormControl({ value: 12, disabled: false }),
      usefulLife: new FormControl({ value: 120, disabled: false }),
      purchaseFactory: new FormControl({ value: '', disabled: false }),
      arrivedDate: new FormControl({ value: '', disabled: false }),
      purchaseAmount: new FormControl({ value: 0, disabled: false }),
      facilityAlarmShow: new FormControl({ value: 0, disabled: false }),
      facilityStateShow: new FormControl({ value: 0, disabled: false }),
      facilityLiablePerson: new FormControl({ value: '', disabled: false }),
      facilityEquipmentPoint: new FormControl({ value: '', disabled: false }),
      facilityDescription: new FormControl({ value: '', disabled: false })
    });
    if (this.code === 0 || this.code === 2) {
      this.validateForm.get('facilityId')
        .setValue(!this.isEmpty(this.currentFacility.epNo) ? this.currentFacility.epNo : '无');
      this.validateForm.get('facilityName')
        .setValue(!this.isEmpty(this.currentFacility.epName) ? this.currentFacility.epName : '无');
      this.validateForm.get('facilityIntact')
        .setValue(!this.isEmpty(this.currentFacility.intactState) ? this.currentFacility.intactState : '无');
      this.validateForm.get('facilityType')
        .setValue(!this.isEmpty(this.currentFacility.assetTypeName) ? this.currentFacility.assetTypeName : '无');
      this.validateForm.get('facilityModel')
        .setValue(!this.isEmpty(this.currentFacility.equipmentType) ? this.currentFacility.equipmentType : '无');
      this.validateForm.get('facilityStatus')
        .setValue(!this.isEmpty(this.currentFacility.runningState) ? this.currentFacility.runningState : '无');
      this.validateForm.get('facilityUser')
        .setValue(!this.isEmpty(this.currentFacility.usePerson) ? this.currentFacility.usePerson : '无');
      this.validateForm.get('userDepartment')
        .setValue(!this.isEmpty(this.currentFacility.useDepartmentName) ? this.currentFacility.useDepartmentName : '无');
      this.validateForm.get('boughtTime')
        .setValue(!this.isEmpty(this.currentFacility.buyDateStr) ? this.currentFacility.buyDateStr : '2022-01-01');
      this.validateForm.get('facilityCompany')
        .setValue(!this.isEmpty(this.currentFacility.useCompanyName) ? this.currentFacility.useCompanyName : '无');
      this.validateForm.get('lifeCycle')
        .setValue(!this.isEmpty(this.currentFacility.lifeCycle) ? this.currentFacility.lifeCycle : '无');
      this.validateForm.get('barCode')
        .setValue(!this.isEmpty(this.currentFacility.barCode) ? this.currentFacility.barCode : '无');
      this.validateForm.get('facilityMade')
        .setValue(!this.isEmpty(this.currentFacility.purchaseCountry) ? this.currentFacility.purchaseCountry : '无');
      this.validateForm.get('facilitySpecs')
        .setValue(!this.isEmpty(this.currentFacility.specs) ? this.currentFacility.specs : '无');
      this.validateForm.get('power')
        .setValue(!this.isEmpty(this.currentFacility.power) ? this.currentFacility.power : 0);
      this.validateForm.get('facilitySubtype')
        .setValue(!this.isEmpty(this.currentFacility.subAssetType) ? this.currentFacility.subAssetType : '无');
      this.validateForm.get('assetLevel')
        .setValue(!this.isEmpty(this.currentFacility.assetLevel) ? this.currentFacility.assetLevel : '无');
      this.validateForm.get('voltageType')
        .setValue(!this.isEmpty(this.currentFacility.voltageType) ? this.currentFacility.voltageType : '无');
      this.validateForm.get('facilitySN')
        .setValue(!this.isEmpty(this.currentFacility.sn) ? this.currentFacility.sn : '无');
      this.validateForm.get('storeLocation')
        .setValue(!this.isEmpty(this.currentFacility.storeLocation) ? this.currentFacility.storeLocation : '无');
      this.validateForm.get('userLocation')
        .setValue(!this.isEmpty(this.currentFacility.userLocation) ? this.currentFacility.userLocation : '无');
      this.validateForm.get('changeState')
        .setValue(!this.isEmpty(this.currentFacility.changeState) ? this.currentFacility.changeState : '无');
      this.validateForm.get('repairPeriod')
        .setValue(!this.isEmpty(this.currentFacility.repairPeriod) ? this.currentFacility.repairPeriod : 0);
      this.validateForm.get('repairLimited')
        .setValue(!this.isEmpty(this.currentFacility.repairLimited) ? this.currentFacility.repairLimited : 0);
      this.validateForm.get('usefulLife')
        .setValue(!this.isEmpty(this.currentFacility.usefulLife) ? this.currentFacility.usefulLife : 0);
      this.validateForm.get('purchaseFactory')
        .setValue(!this.isEmpty(this.currentFacility.purchaseFactory) ? this.currentFacility.purchaseFactory : '无');
      this.validateForm.get('arrivedDate')
        .setValue(!this.isEmpty(this.currentFacility.arrivedDate) ? this.currentFacility.arrivedDate : '2022-01-01');
      this.validateForm.get('purchaseAmount')
        .setValue(!this.isEmpty(this.currentFacility.purchaseAmount) ? this.currentFacility.purchaseAmount : 0);
      this.validateForm.get('facilityAlarmShow')
        // tslint:disable-next-line: radix
        .setValue(!this.isEmpty(this.currentFacility.alarmShowFlag) ? parseInt(this.currentFacility.alarmShowFlag) : '无');
      this.validateForm.get('facilityStateShow')
        // tslint:disable-next-line: radix
        .setValue(!this.isEmpty(this.currentFacility.stateShowFlag) ? parseInt(this.currentFacility.stateShowFlag) : '无');
      this.validateForm.get('facilityLiablePerson')
        .setValue(!this.isEmpty(this.currentFacility.liablePerson) ? this.currentFacility.liablePerson : '无');
      this.validateForm.get('facilityEquipmentPoint')
        .setValue(!this.isEmpty(this.currentFacility.equipmentPoint) ? this.currentFacility.equipmentPoint : '');
      this.validateForm.get('facilityDescription')
        .setValue(!this.isEmpty(this.currentFacility.epRemark) ? this.currentFacility.epRemark : '无');
      if (this.code === 0) {
        this.validateForm.disable();
      }
      if (this.code === 2) {
        this.validateForm.get('facilityId').disable();
      }
    }
  }

  async submitForm() {
    this.validateForm.enable();
    try {
      this.validateForm.setValue({
        facilityId: this.validateForm.value.facilityId,
        facilityName: this.validateForm.value.facilityName,
        facilityIntact: this.validateForm.value.facilityIntact,
        facilityType: this.validateForm.value.facilityType,
        facilityModel: this.validateForm.value.facilityModel,
        facilityStatus: this.validateForm.value.facilityStatus,
        facilityUser: this.validateForm.value.facilityUser,
        userDepartment: this.validateForm.value.userDepartment,
        boughtTime: this.validateForm.value.boughtTime,
        facilityCompany: this.validateForm.value.facilityCompany,
        lifeCycle: this.validateForm.value.lifeCycle,
        barCode: this.validateForm.value.barCode,
        facilityMade: this.validateForm.value.facilityMade,
        facilitySpecs: this.validateForm.value.facilitySpecs,
        power: this.validateForm.value.power,
        facilitySubtype: this.validateForm.value.facilitySubtype,
        assetLevel: this.validateForm.value.assetLevel,
        voltageType: this.validateForm.value.voltageType,
        facilitySN: this.validateForm.value.facilitySN,
        storeLocation: this.validateForm.value.storeLocation,
        userLocation: this.validateForm.value.userLocation,
        changeState: this.validateForm.value.changeState,
        repairPeriod: this.validateForm.value.repairPeriod,
        repairLimited: this.validateForm.value.repairLimited,
        usefulLife: this.validateForm.value.usefulLife,
        purchaseFactory: this.validateForm.value.purchaseFactory,
        arrivedDate: this.validateForm.value.arrivedDate,
        purchaseAmount: this.validateForm.value.purchaseAmount,
        facilityAlarmShow: this.validateForm.value.facilityAlarmShow,
        facilityStateShow: this.validateForm.value.facilityStateShow,
        facilityLiablePerson: this.validateForm.value.facilityLiablePerson,
        facilityEquipmentPoint: this.validateForm.value.facilityEquipmentPoint,
        facilityDescription: this.validateForm.value.facilityDescription,
      });
    } catch (error) {
      this.message.create('error', '请填写必填项!');
    }
  }

  confirmModal() {
    this.modal.destroy();
  }

  async saveModal() {
    if (this.code === 1) {
      if (this.isEmpty(this.validateForm.value.facilityId)) {
        this.message.create('error', '请输入物资编号!');
        return;
      }
      if (this.isEmpty(this.validateForm.value.facilityName)) {
        this.message.create('error', '请输入物资名称!');
        return;
      }
      if (this.isEmpty(this.validateForm.value.facilityType)) {
        this.message.create('error', '请输入物资类型!');
        return;
      }
      if (this.isEmpty(this.validateForm.value.facilitySubtype)) {
        this.message.create('error', '请输入物资子类型!');
        return;
      }
      // tslint:disable-next-line:max-line-length
      if (!this.checkPurchaseAmount(this.validateForm.value.purchaseAmount)) {
        this.message.create('error', '请在购买金额项输入数字!');
        return;
      }
      const result: any = await this.equipmentService.addEquipment({
        epNo: this.validateForm.value.facilityId,
        epName: this.validateForm.value.facilityName,
        assetTypeName: this.validateForm.value.facilityType,
        equipmentType: this.validateForm.value.facilityModel,
        runningState: this.validateForm.value.facilityStatus,
        usePerson: this.validateForm.value.facilityUser,
        useDepartmentName: this.validateForm.value.userDepartment,
        useDepartmentNamePath: this.validateForm.value.userDepartment,
        buyDateStr: this.validateForm.value.boughtTime,
        useCompanyName: this.validateForm.value.facilityCompany,
        useCompanyNamePath: this.validateForm.value.facilityCompany,
        lifeCycle: this.validateForm.value.lifeCycle,
        barCode: this.validateForm.value.barCode,
        purchaseCountry: this.validateForm.value.facilityMade,
        specs: this.validateForm.value.facilitySpecs,
        power: this.validateForm.value.power,
        subAssetType: this.validateForm.value.facilitySubtype,
        assetLevel: this.validateForm.value.assetLevel,
        voltageType: this.validateForm.value.voltageType,
        sn: this.validateForm.value.facilitySN,
        storeLocation: this.validateForm.value.storeLocation,
        userLocation: this.validateForm.value.userLocation,
        changeState: this.validateForm.value.changeState,
        repairPeriod: this.validateForm.value.repairPeriod,
        repairLimited: this.validateForm.value.repairLimited,
        usefulLife: this.validateForm.value.usefulLife,
        purchaseFactory: this.validateForm.value.purchaseFactory,
        arrivedDate: this.validateForm.value.arrivedDate,
        purchaseAmount: this.validateForm.value.purchaseAmount,
        alarmShowFlag: this.validateForm.value.facilityAlarmShow,
        stateShowFlag: this.validateForm.value.facilityStateShow,
        liablePerson: this.validateForm.value.facilityLiablePerson,
        equipmentPoint: this.validateForm.value.facilityEquipmentPoint,
        epRemark: this.validateForm.value.facilityDescription,
        createBy: this.userInfo.userName,
        updateBy: this.userInfo.userName,
      });
      if (result.code === 200) {
        this.message.create('success', '创建物资成功!');
        this.modal.destroy();
      } else {
        if (!this.isEmpty(result.msg)){
          this.message.create('error', result.msg);
        }else{
          this.message.create('error', '创建物资失败!');
        }
      }
    } else if (this.code === 2) {
      this.equipmentService.editEquipment({
        epNo: this.currentFacility.epNo,
        epName: this.validateForm.value.facilityName,
        assetTypeName: this.validateForm.value.facilityType,
        equipmentType: this.validateForm.value.facilityModel,
        runningState: this.validateForm.value.facilityStatus,
        usePerson: this.validateForm.value.facilityUser,
        useDepartmentName: this.validateForm.value.userDepartment,
        useDepartmentNamePath: this.validateForm.value.userDepartment,
        buyDateStr: this.validateForm.value.boughtTime,
        useCompanyName: this.validateForm.value.facilityCompany,
        useCompanyNamePath: this.validateForm.value.facilityCompany,
        lifeCycle: this.validateForm.value.lifeCycle,
        barCode: this.validateForm.value.barCode,
        purchaseCountry: this.validateForm.value.facilityMade,
        specs: this.validateForm.value.facilitySpecs,
        power: this.validateForm.value.power,
        subAssetType: this.validateForm.value.facilitySubtype,
        assetLevel: this.validateForm.value.assetLevel,
        voltageType: this.validateForm.value.voltageType,
        sn: this.validateForm.value.facilitySN,
        storeLocation: this.validateForm.value.storeLocation,
        userLocation: this.validateForm.value.userLocation,
        changeState: this.validateForm.value.changeState,
        repairPeriod: this.validateForm.value.repairPeriod,
        repairLimited: this.validateForm.value.repairLimited,
        usefulLife: this.validateForm.value.usefulLife,
        purchaseFactory: this.validateForm.value.purchaseFactory,
        arrivedDate: this.validateForm.value.arrivedDate,
        purchaseAmount: this.validateForm.value.purchaseAmount,
        alarmShowFlag: this.validateForm.value.facilityAlarmShow,
        stateShowFlag: this.validateForm.value.facilityStateShow,
        liablePerson: this.validateForm.value.facilityLiablePerson,
        equipmentPoint:
          this.isEmpty(this.validateForm.value.facilityEquipmentPoint) ? null : this.validateForm.value.facilityEquipmentPoint,
        epRemark: this.validateForm.value.facilityDescription,
        updateBy: this.userInfo.userName,
      }).subscribe(async (res) => {
        if (res.code === 200) {
          this.message.create('success', '物资修改成功!');
          // 根据物资的sn删除bms_state表中的数据
          const reg = /\s+/g;
          if (this.currentFacility.stateShowFlag.replace(reg, '') === '1' && String(this.validateForm.value.facilityStateShow).replace(reg, '') === '0') {
            // 根据sn发送请求删除bms_state表中的数据
            const result: any = await this.equipmentService.deleteFacilityBmsState(this.validateForm.value.facilitySN);
            if (result.code === 200) {
              this.message.success('删除该物资的BMSState成功！');
            } else {
              // this.message.error('删除该物资的BMSState失败！');
            }
          }
          this.modal.destroy();
        } else {
          if (!this.isEmpty(res.msg)){
            this.message.error(res.msg);
          }else{
            this.message.error('物资修改失败');
          }
        }
      }, err => {
        this.message.error('物资修改失败: ' + err.msg);
      });
    }
  }

  cancelModal() {
    this.modal.destroy();
  }

  /**
   * 处理类型数据
   */
  typeChange(value: string): void {
    this.facilitySubtypes = this.facilitySubtypesBak;
    if (value === null) {
      return;
    }
    const subtypes = [];
    let valueCode = '';
    for (const item of this.facilityTypes) {
      if (item.dictValue === value) {
        valueCode = item.remark;
      }
    }
    for (const element of this.facilitySubtypes) {
      if (valueCode === element.remark.substring(0, 3)) {
        subtypes.push(element);
      }
    }
    this.facilitySubtypes = subtypes;
    this.validateForm.get('facilitySubtype').setValue('');
  }

  /**
   * 查询物资维护数据
   */
  async getEquipmentMaintainData() {
    const facilityLevels: any[] = await this.equipmentService.getDictionaryDataAssetLevel();
    await this.equipmentService.getEquipmentMaintainData().toPromise().then((response: any) => {
      if (response.code === 200) {
        const allType = response.data.物资类型;
        for (const item of allType) {
          if (item.remark.length <= 3) {
            this.facilityTypes.push(item);
          } else {
            this.facilitySubtypes.push(item);
          }
        }
        this.facilitySubtypesBak = this.facilitySubtypes;
        if (this.code === 2) {
          this.typeChange(this.currentFacility.assetTypeName);
          this.validateForm.get('facilitySubtype')
              .setValue(!this.isEmpty(this.currentFacility.subAssetType) ? this.currentFacility.subAssetType : '无');
        }
        // this.facilityLevels = response.data.物资级别;
        this.facilityLevels = facilityLevels;
        this.facilityLifeCycles = response.data.物资生命周期;
        this.facilityDepartments = response.data.物资使用部门;
        this.facilityCompanies = response.data.物资使用公司;
        this.facilityRunningStatuses = response.data.物资运行状态;
        this.facilityCurrentStatues = response.data.物资当前状态;
        this.facilityLocation = response.data.物资位置;
      } else {
        this.message.error('物资维护数据获取失败');
      }
    });
  }

  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }

  transFormMaintainData(name: any) {
    if (name === '设备维护') {
      return '101';
    } else if (name === 'IT') {
      return '102';
    } else if (name === '环境') {
      return '103';
    } else if (name === '家具') {
      return '104';
    } else {
      return name;
    }
  }

  formatIsRepairing(data: any) {
    if (data === '0') {
      return '否';
    } else {
      return '是';
    }
  }
  checkPurchaseAmount(data: string) {
    if (data !== null && data !== '') {
      const reg = /^[0-9]+(.[0-9]{0,2})?$/g;
      return reg.test(data);
    }
  }
}
